import { useTranslation } from "react-i18next";
import { translateAnimalCategoryDescription } from "../../../../i18n/translateAnimalCategory";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";

interface InfoBatchInventoryAdjustmentProps {
  task: ITaskBatchInventoryAdjustment;
}

export default function InfoBatchInventoryAdjustment({ task }: InfoBatchInventoryAdjustmentProps) {
  const { t } = useTranslation();
  const emptyMessage = <div>{t("taskDetails.batchInventoryAdjustment.empty")}</div>;

  if (!task.batches?.length) return emptyMessage;

  return (
    <>
      {task.batches.map((batch, batchIndex) => (
        <section key={`${batch.initials}-${batchIndex}`} className="batchInventoryAdjustmentDetails">
          <div>
            <span>{t("taskDetails.batch")}</span>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <AnimalsIcon width={30} className="iconInitialTaskInfo" />
              <div className="labelInitialTaskInfo">
                <span>{batch.initials}</span>
                <PointIcon width={15} />
              </div>
            </div>
          </div>
          {batch.categories?.length ? batch.categories.map((category, categoryIndex) => (
            <div key={`${category.category_description.id}-${categoryIndex}`} className="containerQuestion">
              <div role="group" aria-label={t("taskDetails.batchInventoryAdjustment.quantity")}>
                <CounterInputV2
                  name={`info-batch-inventory-qty-${batchIndex}-${categoryIndex}`}
                  value={Number(category.quantity ?? 0)}
                  disabled
                />
              </div>
              <MessageBalloon text={translateAnimalCategoryDescription(category.category_description)} />
            </div>
          )) : emptyMessage}
        </section>
      ))}
    </>
  );
}
